import { MEDLEVE_ORIGIN } from '../constants'
import { MEDICAL_TEAM_PATH } from '../registry/doctors'
import { canonicalUrl } from '../urls'

/**
 * Stable @id helpers (PRD §40). One entity = one @id across the whole site.
 * Always derived from the canonical URL, so tracking params can never fork an identifier.
 */
export const organizationId = (): string => `${MEDLEVE_ORIGIN}/#organization`
export const websiteId = (): string => `${MEDLEVE_ORIGIN}/#website`
export const webPageId = (path: string): string => `${canonicalUrl(path)}#webpage`
export const entityId = (path: string): string => `${canonicalUrl(path)}#entity`
export const breadcrumbId = (path: string): string => `${canonicalUrl(path)}#breadcrumb`
export const faqId = (path: string): string => `${canonicalUrl(path)}#faq`
export const doctorPath = (slug: string): string => `${MEDICAL_TEAM_PATH}/${slug}`
export const personId = (slug: string): string => `${canonicalUrl(doctorPath(slug))}#person`
export const profileId = (slug: string): string => `${canonicalUrl(doctorPath(slug))}#profile`

// A type alias (not an interface) so it stays assignable to the JSON-LD value index signature.
export type IdRef = { '@id': string }

export const ref = (id: string): IdRef => ({ '@id': id })
